export default () => {
  return {
    registration: null,
  };
};
